module.exports = __webpack_public_path__ + "static/img/ai_scan_dark.4ce2e1c4.jpg";